import MainLayout from "../../MainLayout";

const Contact = () => {
	return (
		<MainLayout color={"black"} page={"contact"}>
			<section className="relative grid place-content-center h-screen">
				<img className="absolute top-0 left-0 h-full w-full object-cover brightness-[30%] -z-10" src="./assets/contact-bg.jpg" alt="" />
				<div className=" my-16 mx-8 lg:mx-32 text-white">
					<h1 className="text-[3rem] mr-5 font-cairo font-bold lg:mr-0 lg:text-[3.5rem] ">لا تستحي, وتواصل معي</h1>
					<a href="tel:+972542851590">
						<p className="text-2xl mt-16 mx-12 lg:text-3xl lg:mx-16">
							الهاتف:{" "}
							<span dir="ltr" className="underline">
								+972542851590
							</span>
						</p>
					</a>
					<a rel="noreferrer" target={"_blank"} href="https://t.me/issam_alashhab">
						<p className="text-2xl mt-16 mx-12 lg:text-3xl lg:mx-16">
							<img className="w-[50px] inline-block" src="./assets/telegram-logo.png" alt="" /> -{" "}
							<span dir="ltr" className="underline">
								@Issam AL-Ashhab
							</span>
						</p>
					</a>
					<a rel="noreferrer" target={"_blank"} href="mailto:Issam.al.ashhab.photo@gmail.com">
						<p className="text-2xl mt-16 mx-12 lg:text-3xl lg:mx-16">
							{" "}
							<img className="w-[50px] inline-block" src="./assets/mail-logo.png" alt="" /> -{" "}
							<span dir="ltr" className="underline">
								Issam.al.ashhab.photo@gmail.com
							</span>
						</p>
					</a>
				</div>
			</section>
		</MainLayout>
	);
};

export default Contact;
